import { assertSheetsProvider } from "@/api/sheets.provider";
import { sheetsProviderSource } from "@/runtime/sheets-provider-source";

export const sheetsRuntimeProvider = assertSheetsProvider(
  sheetsProviderSource,
);
